import { render, staticRenderFns } from "./SelectDropdown.vue?vue&type=template&id=6b0e48e0"
import script from "./SelectDropdown.vue?vue&type=script&lang=js"
export * from "./SelectDropdown.vue?vue&type=script&lang=js"
import style0 from "./SelectDropdown.vue?vue&type=style&index=0&id=6b0e48e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports